import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import styled from 'styled-components'
import { Measure, Divider, Heading, Subhead, Flex } from 'rebass'
import { DateLabel } from '../components/Styled'

const PostBody = styled(Measure)`
  /* center captions beneath images. it's an 'a' tag instead of 'img' b/c gatsby-images 
  *  wraps images in links to their full size version. */
  a + em {
    display: block;
    text-align: center;
  }
`
class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const { previous, next } = this.props.pathContext

    return (
      <Flex
        py={4}
        width={'100%'}
        style={{ flex: 1 }}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`} />
        <Flex
          style={{
            maxWidth: 576, // max width for the body content, courtesy of Measure
          }}
          flexDirection={'column'}
          width={'100%'}
        >
          <DateLabel
            style={{
              display: 'block',
            }}
          >
            {post.frontmatter.date}
          </DateLabel>
          <h1>{post.frontmatter.title}</h1>
          <div
            style={{
              width: '50px',
              border: '1px solid fuchsia',
              marginBottom: '2rem',
            }}
          />
        </Flex>
        <PostBody dangerouslySetInnerHTML={{ __html: post.html }} />
        <Divider style={{ marginTop: 'auto' }} width={'100%'} />

        <Flex
          justifyContent={'space-around'}
          alignItems={['center', 'center', 'space-around', 'space-around']}
          flexDirection={['column', 'column', 'row', 'row']}
          width={'100%'}
        >
          {previous ? (
            <Link to={previous.fields.slug} rel="prev">
              ← {previous.frontmatter.title}
            </Link>
          ) : (
            <div />
          )}
          <Link to={'/writing/'}>↑ all posts</Link>
          {next ? (
            <Link to={next.fields.slug} rel="next">
              {next.frontmatter.title} →
            </Link>
          ) : (
            <div />
          )}
        </Flex>
      </Flex>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js